import type { AssetCreationFlow, RuntimeFlagResolutionSource } from "@runcheetah/shared";

export const getAutopilotStatusCopy = (enabled: boolean) =>
  enabled
    ? {
        eyebrow: "Autopilot is active",
        title: "Campaigns generate automatically",
        description:
          "Cheetah will keep creating campaign drafts from the active strategy and queue the next run after each cycle.",
        actionLabel: "Turn off Autopilot",
      }
    : {
        eyebrow: "Autopilot is paused",
        title: "Campaign generation is manual",
        description:
          "Cheetah will not start new automatic campaign generation jobs until Autopilot is turned back on.",
        actionLabel: "Turn on Autopilot",
      };

export const getAssetCreationFlowCopy = (flow: AssetCreationFlow) =>
  flow === "freestyle"
    ? {
        eyebrow: "Freestyle mode",
        title: "Cheetah can design without a template",
        description:
          "Single assets can use brand context and creative direction without being forced into a published layout template.",
        optionTitle: "Freestyle",
        optionDescription: "Best when you want more layout variety for single-image posts.",
      }
    : {
        eyebrow: "Template mode",
        title: "Single assets use approved templates",
        description:
          "Cheetah will choose from published layout templates when generating new single-image assets.",
        optionTitle: "Template",
        optionDescription: "Best when you want stricter consistency with approved layouts.",
      };

export const getAssetCreationSourceCopy = (source: RuntimeFlagResolutionSource) =>
  source === "brand"
    ? "Brand setting"
    : source === "global"
      ? "Workspace default"
      : "Default setting";
